import {AbstractControl, FormGroup, NG_VALIDATORS, Validator, ValidatorFn} from '@angular/forms';
import {Directive} from '@angular/core';

export function exceptionValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        let formGroup = <FormGroup>control;
        for(let controlName of Object.keys(formGroup.controls)) {
            const control = formGroup.get(controlName);
            if(!control.valid && control.dirty) {
                return {
                    atLeastOneControlHasError: true
                }
            }
        }
        return null;
    }
}

/**
 * Invalidates form group when at least one of its controls is dirty and not valid
 */
@Directive({
    selector: '[ngModelGroup][tflValidException]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: ExceptionValidatorDirective,
        multi: true
    }]
})
export class ExceptionValidatorDirective implements Validator {
    validate(control: AbstractControl): { [key: string]: any } {
        return exceptionValidator()(control);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/exceptions/exception-validator.directive.ts